import { render, staticRenderFns } from "./SysSementosAutocomplete.vue?vue&type=template&id=1d727678"
import script from "./SysSementosAutocomplete.vue?vue&type=script&lang=js"
export * from "./SysSementosAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports